import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Training Attendance (Trainee) ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-auto" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row mt-3" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Course", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Batches", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch Term", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "col-md-2 mt-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_detail",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Batch Calender (Select the training day to enter the attendance data) ")
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  id: "batch_detail",
  class: "collapse show"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "collapse show" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body border-top p-5" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "pt-0" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row g-6 g-xl-6 mb-6 mb-xl-9" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-xl-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card h-70" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center text-center flex-column p-8" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 text-hover-primary d-flex flex-column" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder mb-2" }, " 02-07-2016 (02-07-2016) "),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#TrainingDetails"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-primary mr-1 badge-pill fs-8",
                      style: {"padding":"8px !important"}
                    }, "Update")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#loadAttendance"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-info mr-1 badge-pill mt-1 fs-8",
                      style: {"padding":"8px !important"}
                    }, "Attendance")
                  ])
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-xl-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card h-70" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center text-center flex-column p-8" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 text-hover-primary d-flex flex-column" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder mb-2" }, " 02-07-2016 (02-07-2016) "),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#TrainingDetails"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-primary mr-1 badge-pill fs-8",
                      style: {"padding":"8px !important"}
                    }, "Update")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#loadAttendance"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-info mr-1 badge-pill mt-1 fs-8",
                      style: {"padding":"8px !important"}
                    }, "Attendance")
                  ])
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-xl-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card h-70" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center text-center flex-column p-8" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 text-hover-primary d-flex flex-column" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder mb-2" }, " 02-07-2016 (02-07-2016) "),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#TrainingDetails"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-primary mr-1 badge-pill fs-8",
                      style: {"padding":"8px !important"}
                    }, "Update")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#loadAttendance"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-info mr-1 badge-pill mt-1 fs-8",
                      style: {"padding":"8px !important"}
                    }, "Attendance")
                  ])
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-xl-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card h-70" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center text-center flex-column p-8" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 text-hover-primary d-flex flex-column" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder mb-2" }, " 02-07-2016 (02-07-2016) "),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#TrainingDetails"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-primary mr-1 badge-pill fs-8",
                      style: {"padding":"8px !important"}
                    }, "Update")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#loadAttendance"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-info mr-1 badge-pill mt-1 fs-8",
                      style: {"padding":"8px !important"}
                    }, "Attendance")
                  ])
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-xl-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card h-70" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center text-center flex-column p-8" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 text-hover-primary d-flex flex-column" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder mb-2" }, " 02-07-2016 (02-07-2016) "),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#TrainingDetails"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-primary mr-1 badge-pill fs-8",
                      style: {"padding":"8px !important"}
                    }, "Update")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#loadAttendance"
                  }, [
                    /*#__PURE__*/_createElementVNode("span", {
                      class: "badge badge-info mr-1 badge-pill mt-1 fs-8",
                      style: {"padding":"8px !important"}
                    }, "Attendance")
                  ])
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col d-none d-xl-block" }),
          /*#__PURE__*/_createElementVNode("div", { class: "col d-none d-xl-block" })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title p-3" }, "Trainee Attendance"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "No Data Available")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.batch.tranche_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tranche-1",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-1")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-2",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-2")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-3",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-3")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-4",
                            value: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-4")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _hoisted_13,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Association",
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.entity_short_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("[" + _toDisplayString(info.entity_short_name) + "]-" + _toDisplayString(info.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Institute",
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.entity_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _hoisted_20,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Course",
                        modelValue: _ctx.batch.tranche_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tranche-1",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-1")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-2",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-2")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-3",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-3")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Tranche-4",
                            value: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Tranche-4")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Courses",
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.entity_short_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Batch",
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.entity_short_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.courseNotice())),
                        type: "button",
                        class: "btn btn-success p-3 mt-5",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_28
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.showCourseNotice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _hoisted_33
  ], 64))
}